/**
@description 设置路由路径
*/

import Services from './Services'
import HuoKe from './HuoKe'
import JiQiRen from "./JiQiRen";
import FengKong from './FengKong'
import Automl from './Automl'
import FangAn from './FangAn'
import Saas from './Saas'
import LuoWang from './LuoWang'
import ShangCe from './ShangCe'
import FengChao from './FengChao'
import SubmitForm from './SubmitForm'

export const servicesRouting = [
  {
    path: 'services',
    component: Services,
    name: '智能获客',
    indexRoute: {
      name: '产品与服务',
      component: HuoKe,
      title: '产品与服务-智能获客',
      catname: 'huoke'
    },
    childRoutes: [
      {
        path: 'huoke',
        name: '智能获客',
        title: '产品与服务-智能获客',
        component: HuoKe
      },{
        path: 'fengkong',
        name: '智能风控',
        title: '产品与服务-智能风控',
        component: FengKong
      },{
        path: 'jiqiren',
        name: '智能语音机器人',
        title: '产品与服务-智能语音机器人',
        component: JiQiRen
      },{
        path: 'automl',
        name: 'automl自动建模平台',
        title: '产品与服务-automl自动建模平台',
        component: Automl
      },{
        path: 'fangan',
        name: '一站式信贷解决方案',
        title: '产品与服务-一站式信贷解决方案',
        component: FangAn
      },{
        path: 'saas',
        name: '海外SaaS服务',
        title: '产品与服务-海外SaaS服务',
        component: Saas
      },{
        path: 'luowang',
        name: '反欺诈系统-罗网',
        title: '产品与服务-反欺诈系统-罗网',
        component: LuoWang
      },{
        path: 'shangce',
        name: '策略引擎–上策',
        title: '产品与服务-策略引擎–上策',
        component: ShangCe
      },{
        path: 'fengchao',
        name: '指标计算平台–蜂巢',
        title: '产品与服务-指标计算平台–蜂巢',
        component: FengChao
      },{
        path: 'submitform',
        name: '方案咨询',
        title: '产品与服务-方案咨询',
        component: SubmitForm
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./modules/services/routing.js